import script from "./ZhimaSeriesList.vue?vue&type=script&setup=true&lang=js"
export * from "./ZhimaSeriesList.vue?vue&type=script&setup=true&lang=js"

import "./ZhimaSeriesList.vue?vue&type=style&index=0&id=63572ae9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63572ae9"]])

export default __exports__